/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { createI } from '../../factoriesAny.js';
export var iDependencies = {
  ComplexDependencies: ComplexDependencies,
  createI: createI
};